import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  ComplianceFormPrefillDataQuery,
  GetMeQuery,
  ProjectByIdQuery,
} from '../../../gql/graphql';
import projectKeys from '../project/keyFactory';
import complianceKeys from './keyFactory';

const GetComplianceFormPrefillData = graphql(`
  query ComplianceFormPrefillData($projectId: ID!) {
    me {
      user {
        account {
          name
        }
      }
    }
    projectById(id: $projectId) {
      customer {
        name
        primaryContact {
          email
          phone
        }
      }
      addresses {
        site {
          line1
          line2
          city
          country
          administrativeArea
          postalCode
        }
      }
      owner {
        fullName
        email
        phone
      }
    }
  }
`);

const useGetComplianceFormPrefillData = (projectId: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    enabled: !!projectId,
    queryKey: complianceKeys.formPrefill(projectId),
    queryFn: () => {
      return gqlClient.request(GetComplianceFormPrefillData, {
        projectId,
      });
    },
    initialData: () => {
      const meData = queryClient.getQueryData<GetMeQuery>(meKeys.all);
      const projectData = queryClient.getQueryData<ProjectByIdQuery>(
        projectKeys.overview(projectId)
      );

      if (!meData && !projectData) {
        return;
      }

      const initial: ComplianceFormPrefillDataQuery = {
        me: {
          user: {
            account: {
              ...meData?.me?.user.account,
              name: meData?.me?.user.account.name || '',
            },
          },
        },
        projectById: {
          ...projectData?.projectById,
          customer: {
            ...projectData?.projectById?.customer,
            name: projectData?.projectById?.customer?.name || '',
          },
          addresses: {
            site: projectData?.projectById?.addresses?.site || [],
          },
        },
      };
      return initial;
    },
  });
};

export default useGetComplianceFormPrefillData;
